import type { DefaultRootState } from 'react-redux';

import { isNeedTopUp } from 'utils/balance/isNeedTopUp';

import createReducer, { ActionCreatorHelper } from 'store/createReducer';
import { selectAvailableBalance } from 'store/models/balance';

export interface StoppedCampaignsDto {
    existStoppedDueToExhaustedAccountBalance: boolean;
}

interface StoppedCampaignsState {
    existStoppedDueToExhaustedAccountBalance: boolean;
}

// ----------------------- actions -------------------------------------
const SET_STOPPED_CAMPAIGNS = 'SET_STOPPED_CAMPAIGNS';

interface PayloadTypes {
    [SET_STOPPED_CAMPAIGNS]: StoppedCampaignsDto;
}

const ActionCreator = ActionCreatorHelper<PayloadTypes>();

export const setStoppedCampaigns = ActionCreator(SET_STOPPED_CAMPAIGNS);
// ----------------------- /actions -------------------------------------

// ----------------------- reducer --------------------------------------
const INITIAL_STATE: StoppedCampaignsState = {
    existStoppedDueToExhaustedAccountBalance: false,
};

export default createReducer<StoppedCampaignsState, PayloadTypes>(INITIAL_STATE, {
    [SET_STOPPED_CAMPAIGNS]: (state, { payload }) => ({
        ...state,
        existStoppedDueToExhaustedAccountBalance: payload.existStoppedDueToExhaustedAccountBalance,
    }),
});
// ----------------------- /reducer --------------------------------------

// ----------------------- selectors ------------------------------------
export const selectExistStoppedDueToExhaustedAccountBalance = (state: DefaultRootState): boolean =>
    state.stoppedCampaigns.existStoppedDueToExhaustedAccountBalance;

export const selectNeedTopUp = (state: DefaultRootState): boolean =>
    isNeedTopUp(selectAvailableBalance(state), selectExistStoppedDueToExhaustedAccountBalance(state));
// ----------------------- /selectors ------------------------------------
